export default function() {
  return !this.node();
}



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/d3-selection/src/selection/empty.js
// module id = ../../../../d3-selection/src/selection/empty.js
// module chunks = 4